<template>
    <v-dialog v-model="dialog" max-width="600" @click:outside="hide">
        <v-card tile>
            <v-card-title>
                <v-icon color="black" left size="40">mdi-chart-box-outline</v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Editar' : 'Crear' }} Presupuesto
                    <div class="title-subtext">
                        Completa los siguientes datos
                    </div>
                </div>
                <v-spacer />
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <!-- HEADERS INPUTS -->
                <v-row class="py-5">
                    <v-col cols="12" md="6">
                        <kimsa-select label="Cliente" placeholder="Selecciona un cliente" bolder-label :items="clients"
                            outlined solo flat dense item-text="name" item-value="id" :readonly="editMode || !!clientId"
                            force-value :value="client" @change="client = $event" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <kimsa-date-picker label="Año" placeholder="AAAA" bolder-label outlined solo flat dense
                            force-value :min="minYear" :max="maxYear" year-mode :allowed-dates="allowedDates"
                            :value="year" @change="year = $event" />
                    </v-col>
                </v-row>

                <v-row class="background-carousel">
                    <!-- INPUTS -->
                    <v-col cols="12">
                        <kimsa-file label="Documento" outlined dense @change="file = $event" placeholder="Seleccionar"
                            mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                    </v-col>
                    <v-col cols="12" class="text-right">
                        <a :href="`${baseUrl}/samples/budgets.xlsx`">
                            Descargar formato
                        </a>
                    </v-col>

                </v-row>
                <!-- CONTINUE & BACK -->
                <v-row class="pa-3">
                    <v-spacer />
                    <v-btn @click="editMode ? editBudget() : saveBudget()" color="primary" depressed tile
                        :disabled="!validSave" :loading="loading">
                        Guardar Presupuesto
                    </v-btn>
                    <v-spacer />
                </v-row>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import * as XLSX from 'xlsx'
import { mapMutations, mapState } from "vuex";
import Axios from "@/utils/Axios";
import KimsaSelect from "@/components/common/inputs/KimsaSelect";
import KimsaDatePicker from "@/components/common/inputs/KimsaDatePicker";
import KimsaFile from '../common/inputs/KimsaFile.vue';

export default {
    name: "CreateBudgetExcelDialog",
    components: { KimsaDatePicker, KimsaSelect, KimsaFile },
    data() {
        return {
            dialog: false,
            loading: false,
            editMode: false,
            budget: null,
            hasFinancial: false,
            carousel: 0,
            clients: [],
            client: null,
            year: `${new Date().getFullYear()}-01-01`,
            revenue: [],
            costSale: [],
            operatingExpenses: [],
            otherExpenses: [],
            template: { name: '' },
            budgetYears: [],
            file: null,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        validSave(vm = this) {
            return true
            // let validRevenue = vm.revenue.filter(r => !r.name).length === 0
            // let validCostSale = vm.costSale.filter(r => !r.name).length === 0
            // let validOperatingExpenses = vm.operatingExpenses.filter(r => !r.name).length === 0
            // let validOtherExpenses = vm.otherExpenses.filter(r => !r.name).length === 0
            // return !!vm.client && !!vm.year && !!vm.file && validRevenue && validCostSale && validOperatingExpenses && validOtherExpenses
        },
        clientId() {
            return this.$route.params.id || null
        },
        minYear() {
            return `${new Date().getFullYear() - 10}-01-01`
        },
        maxYear() {
            return `${new Date().getFullYear() + 1}-12-31`
        },
        baseUrl() {
            return process.env.VUE_APP_BASE_URL || null
        },
    },
    async mounted() {
        const vm = this
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show() {
            const vm = this
            await vm.loadClients()
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.carousel = 0
            vm.budget = null
            vm.hasFinancial = false
            vm.client = null
            vm.year = `${new Date().getFullYear()}-01-01`
            vm.revenue = []
            vm.costSale = []
            vm.operatingExpenses = []
            vm.otherExpenses = []
            vm.file = null
        },
        async loadClients() {
            const vm = this
            await Axios.get(`clients`).then(res => {
                // console.log('res loadClients', res)
                vm.clients = res.data.result.clients
                if (vm.clientId) vm.client = Number(vm.clientId)
            }).catch(er => {
                console.log('error loadClients', er)
            })
        },
        async loadBudget(id) {
            const vm = this
            await Axios.get(`budget/${id}`).then(res => {
                // console.log('res loadBudget', res)
                vm.budget = res.data.result.budget
                vm.hasFinancial = !!vm.budget.financial_statement
                vm.editMode = true
                vm.client = vm.budget.client_id
                vm.year = vm.budget.year
                vm.revenue = vm.budget.revenue
                vm.costSale = vm.budget.cost_sale
                vm.operatingExpenses = vm.budget.operating_expenses
                vm.otherExpenses = vm.budget.other_expenses
                vm.show()
            }).catch(er => {
                console.log('error loadBudget', er)
            })
        },
        async saveBudget() {
            const vm = this
            vm.loading = true
            // console.log('saveBudget', vm)

            await vm.loadExcelValues()

            let payload = {
                client_id: vm.client,
                year: vm.year.split('-')[0],
                revenue: vm.revenue,
                cost_sale: vm.costSale,
                operating_expenses: vm.operatingExpenses,
                other_expenses: vm.otherExpenses,
            }

            console.log('payload', payload)

            await Axios.post('budget/new', payload).then(res => {
                // console.log('res saveBudget',res)
                vm.toast('Presupuesto creado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error saveBudget', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        async editBudget() {
            const vm = this
            vm.loading = true
            // console.log('editBudget', vm)

            vm.loadExcelValues()

            let payload = {
                client_id: vm.client,
                year: vm.year.split('-')[0],
                revenue: vm.revenue,
                cost_sale: vm.costSale,
                operating_expenses: vm.operatingExpenses,
                other_expenses: vm.otherExpenses,
            }

            if (vm.hasFinancial) {
                let newRevenue = vm.revenue.slice(vm.budget.revenue.length)
                let newCostSale = vm.costSale.slice(vm.budget.cost_sale.length)
                let newOperatingExpenses = vm.operatingExpenses.slice(vm.budget.operating_expenses.length)
                let newOtherExpenses = vm.otherExpenses.slice(vm.budget.other_expenses.length)

                payload.has_financial = true
                payload.new_revenue = newRevenue.map(item => { return { name: item.name } })
                payload.new_cost_sale = newCostSale.map(item => { return { name: item.name } })
                payload.new_operating_expenses = newOperatingExpenses.map(item => { return { name: item.name } })
                payload.new_other_expenses = newOtherExpenses.map(item => { return { name: item.name } })
            }

            console.log('payload', payload)

            await Axios.patch(`budget/${vm.budget.id}/edit`, payload).then(res => {
                // console.log('res editBudget',res)
                vm.toast('Presupuesto actualizado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error editBudget', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        allowedDates(val) {
            return !this.budgetYears.some(year => {
                return val >= `${year}-01-01` && val < `${Number(year) + 1}-01-01`
            })
        },
        async getBudgetYears() {
            const vm = this
            if (!vm.client) return
            let budgetYears = await Axios.get(`client/${vm.client}/budget/years`)
            vm.budgetYears = budgetYears.data.result.years
        },
        loadExcelValues() {
            const vm = this;

            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    try {
                        const excel = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(excel, { type: 'array' });

                        vm.revenue = vm.readSheet(workbook, 0);
                        vm.costSale = vm.readSheet(workbook, 1);
                        vm.operatingExpenses = vm.readSheet(workbook, 2);
                        vm.otherExpenses = vm.readSheet(workbook, 3);

                        resolve();
                    } catch (err) {
                        reject(err);
                    }
                };

                reader.onerror = reject;
                reader.readAsArrayBuffer(vm.file);
            });
        },
        readSheet(workbook, sheetIndex) {
            console.log('workbook', workbook, sheetIndex);
            const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
            const sheetName = workbook.SheetNames[sheetIndex];
            const worksheet = workbook.Sheets[sheetName];

            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const result = [];

            for (let rowIndex = 1; rowIndex < rows.length; rowIndex++) {
                const row = rows[rowIndex];
                if (!row || !row[0]) continue;
                const item = { name: row[0] };
                months.forEach((month, i) => {
                    item[month] = Number(row[i + 1] || 0);
                });
                result.push(item);
            }

            return result;
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        client() {
            this.getBudgetYears()
        },
        budgetYears(val) {
            if (val.includes(this.year.split('-')[0]) && !this.editMode) this.year = null
        },
    }
}
</script>

<style scoped>
.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.background-carousel {
    background-color: #f9f9f9;
    border-radius: 5px;
    border: 1px solid #efefef;
    padding: 10px;
    margin: 0;
}
</style>